import { render, staticRenderFns } from "./publicationPage.vue?vue&type=template&id=710c25bc&scoped=true&"
import script from "./publicationPage.vue?vue&type=script&lang=js&"
export * from "./publicationPage.vue?vue&type=script&lang=js&"
import style0 from "./publicationPage.vue?vue&type=style&index=0&id=710c25bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c25bc",
  null
  
)

export default component.exports